export enum ScheduleJobState {
    None = 0,
    Waiting = 1,
    Executed = 2
}